import { render, staticRenderFns } from "./ContractorRoles.vue?vue&type=template&id=0a20beaa&"
import script from "./ContractorRoles.vue?vue&type=script&lang=js&"
export * from "./ContractorRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports